import { render } from "./MessageModalComponent.vue?vue&type=template&id=0fbe9896"
import script from "./MessageModalComponent.vue?vue&type=script&lang=js"
export * from "./MessageModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__